import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import {AppState} from "./State/AppState.jsx"
import { MessagesState } from "./State/MessagesState.jsx";
import { getKeyValue } from "./CommonComponents/CommonWorkers.js";

const initTheme = {}

const initConfig = async () => {
	const res = await getKeyValue("color");
	const headerFontRes = await getKeyValue("headerFontMultiplier");
	const bodyLeftFontMultiplierRes = await getKeyValue(
		"bodyLeftFontMultiplier"
	);
	const bodyCenterFontMultiplierRes = await getKeyValue(
		"bodyCenterFontMultiplier"
	);
	const bodyRightFontMultiplierRes = await getKeyValue(
		"bodyRightFontMultiplier"
	);
	const footerFontMultiplierRes = await getKeyValue("footerFontMultiplier");
	const color = res[0]?.RES;
	const headerFontMultiplier = headerFontRes[0]?.RES;
	const bodyLeftFontMultiplier = bodyLeftFontMultiplierRes[0]?.RES;
	const bodyCenterFontMultiplier = bodyCenterFontMultiplierRes[0]?.RES;
	const bodyRightFontMultiplier = bodyRightFontMultiplierRes[0]?.RES;
	const footerFontMultiplier = footerFontMultiplierRes[0]?.RES;
	const init = {
		color: color,
		headerFontMultiplier: headerFontMultiplier,
		bodyLeftFontMultiplier: bodyLeftFontMultiplier,
		bodyCenterFontMultiplier: bodyCenterFontMultiplier,
		bodyRightFontMultiplier: bodyRightFontMultiplier,
		footerFontMultiplier: footerFontMultiplier,
	};
	return init
};
if(window.location.protocol === "http:" && process.env.NODE_ENV !== "development"){
	window.location.href = "https:" + window.location.hostname
}

initConfig().then((res) => {
	ReactDOM.createRoot(document.getElementById("root")).render(
		<React.StrictMode>
			<AppState>
				<MessagesState>
					<BrowserRouter>
						<App initTheme={res}/>
					</BrowserRouter>
				</MessagesState>	
			</AppState>
		</React.StrictMode>
	);
})
